export const getDomain = (url: string) => new URL(url).hostname;
